<router-outlet />
@if (showLoadingIndicator()) {
  <div
    class="loading_indicator"
    [@fadeInOnEnter]
    [@fadeOutOnLeave]>
    <slnk-common-loading [isPrimary]="true" />
  </div>
}
<p-toast
  key="default"
  position="bottom-left"
  preventOpenDuplicates="true" />
<p-toast
  key="notification"
  position="top-right"
  preventOpenDuplicates="true" />

<p-confirmdialog />
